export function PlaceReminderIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M23 5a4.5 4.5 0 00-9 0c0 2.67 2.62 5.632 3.861 6.886a.89.89 0 001.278 0C20.38 10.632 23 7.67 23 5zm-2 0c0 .743-.394 1.747-1.136 2.875-.43.654-1.041 1.766-1.364 1.766-.323 0-.934-1.112-1.364-1.766C16.394 6.747 16 5.743 16 5a2.5 2.5 0 115 0z"
      ></path>
      <path
        fill="currentColor"
        d="M12 4a1 1 0 00-1 1c0 .25-.092.48-.245.655l-.013.016-.053.063-.198.238c-.17.205-.402.494-.658.828-.522.68-1.101 1.497-1.445 2.16-.38.732-.733 1.778-.998 2.687a32.006 32.006 0 00-.408 1.547l-.004.015a.995.995 0 01-.27.498L4.413 16h15.172l-1.147-1.146c-.939-.94.475-2.354 1.515-1.315L21 14.586c1.26 1.26.367 3.414-1.414 3.414H16a4 4 0 11-8 0H4.414C2.632 18 1.74 15.846 3 14.586l2.093-2.093.052-.21c.076-.302.187-.722.325-1.197.272-.93.669-2.133 1.142-3.046.43-.828 1.1-1.761 1.635-2.458.272-.355.52-.662.699-.88l.08-.097A3 3 0 0112 2c.66 0 1 .5 1 1s-.448 1-1 1zm-2 14a2 2 0 004 0h-4z"
      ></path>
    </svg>
  );
}
